// extracted by mini-css-extract-plugin
module.exports = {"select":"DeviceSelect__select__cPg4i","dropdown":"DeviceSelect__dropdown__3N2Wt","labelInput":"DeviceSelect__labelInput__XzcK8"};